import React from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Label,
  Button,
  Form,
  Input,
  FormFeedback,
  ButtonGroup,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import { useSelector, useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { editOfferStatus, updateOfferStatus } from "../../../store/actions"

import { useEffect, useState } from "react"

const EditOfferStatus = props => {
  const dispatch = useDispatch()
  document.title = "Edit offer status"
  const { id } = useParams()

  const [details, setDetails] = useState({})

  useEffect(() => {
    dispatch(editOfferStatus(id))
  }, [dispatch])

  const offerStats = useSelector(state => state.offerStatus)

  useEffect(() => {
    let offerS = []
    if (
      offerStats &&
      offerStats.offerStatus &&
      offerStats.offerStatus.length > 0
    ) {
      offerS = offerStats.offerStatus.filter(
        offerStatus => offerStatus.offer_status_id == id
      )
    }
    if (offerS.length > 0) {
      setDetails(offerS[0])
    } else {
      props.history.push("/dropdown/material_standard/list")
    }
  }, [])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      offer_status_id:
        details && details.offer_status_id ? details.offer_status_id : "",

      offer_status: details && details.offer_status ? details.offer_status : "",

      is_default: details && details.is_default ? 1 : 0,
    },
    validationSchema: Yup.object({
      offer_status: Yup.string().required("Please enter material standard"),
    }),
    onSubmit: values => {
      values.offer_status_id = id // colli_id is from api thats why this needs to be same with "id"
      dispatch(updateOfferStatus(values, props.history))
    },
  })

  const { error } = useSelector(state => ({
    error: state.offerStatus.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Edit Offer Status" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="editofferStatusForm"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3 mt-1">
                          <Label htmlFor="os">Offer Status</Label>
                          <Input
                            name="offer_status"
                            type="text"
                            id="os"
                            autoComplete="off"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.offer_status || ""}
                          />
                          {validation.touched.offer_status &&
                          validation.errors.offer_status ? (
                            <FormFeedback type="invalid">
                              {validation.errors.offer_status}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      <h6>Default : </h6>
                      <ButtonGroup>
                        <Button
                          name="is_default"
                          color="success"
                          outline
                          value={1}
                          active={validation.values.is_default == 1}
                          onClick={validation.handleChange}
                        >
                          Yes
                        </Button>

                        <Button
                          name="is_default"
                          color="secondary"
                          outline
                          value={0}
                          active={validation.values.is_default == 0}
                          onClick={validation.handleChange}
                        >
                          No
                        </Button>
                      </ButtonGroup>
                    </div>
                    <br />
                    <div>
                      {offerStats && offerStats.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Updating ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Update
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default EditOfferStatus
